"use client";

import { NavMobileMenu } from "@/ui/nav/nav-mobile-menu.client";
import { motion } from "framer-motion";
import Link from "next/link";
import { useEffect, useState } from "react";

const menu = [
	{
		title: "Sistemas",
		href: "/sistemas",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<polygon points="12 2 3 7 3 17 12 22 21 17 21 7 12 2" />
				<path d="M12 2v20" />
				<path d="M3 7l9 5 9-5" />
				<path d="M3 17l9-5 9 5" />
			</svg>
		),
		animation: {
			initial: { rotate: 0, scale: 1 },
			hover: {
				rotate: [0, 15, -15, 0],
				scale: 1.2,
				transition: { duration: 0.6, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.5 },
			},
		},
		submenu: [
			{ title: "Sistemas", href: "/sistemas" },
			{ title: "Dragones & Mazmorras", href: "/Dragones-y-Mazmorras" },
			{ title: "Tarragon", href: "/tarragon" },
			{ title: "Láseres y Sentimientos", href: "/laseres-y-sentimientos" },
		],
	},
	{
		title: "Aventuras",
		href: "/category/aventuras",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M14.5 17.5 3 6V3h3L18 15.5" />
				<path d="m13 19 6-6" />
				<path d="m16 16 4 4" />
				<path d="m21 21-3-3" />
			</svg>
		),
		animation: {
			initial: { x: 0, y: 0 },
			hover: {
				x: [0, 5, -5, 0],
				y: [0, -5, 5, 0],
				transition: { duration: 0.5, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.5 },
			},
		},
		submenu: [],
	},
	{
		title: "Precios",
		href: "/category/precios",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<line x1="12" y1="1" x2="12" y2="23"></line>
				<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
			</svg>
		),
		animation: {
			initial: { rotateZ: 0 },
			hover: {
				rotateZ: 360,
				transition: { duration: 0.7, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.5 },
			},
		},
		submenu: [],
	},
	{
		title: "Ayuda",
		href: "/faq",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<circle cx="12" cy="12" r="10"></circle>
				<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
				<line x1="12" y1="17" x2="12.01" y2="17"></line>
			</svg>
		),
		animation: {
			initial: { scale: 1 },
			hover: {
				scale: [1, 1.2, 0.9, 1.1, 1],
				transition: { duration: 0.5, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.5 },
			},
		},
		submenu: [
			{ title: "FAQ", href: "/faq" },
			{ title: "Contacto", href: "/contacto" },
			{ title: "Los Amos", href: "/los-amos" },
		],
	},
	{
		title: "Servicios",
		href: "/eventos",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M4 16l1-6 4 3 3-5 3 5 4-3 1 6" />
				<path d="M4 20h16" />
				<circle cx="4" cy="10" r="1" />
				<circle cx="12" cy="6" r="1" />
				<circle cx="20" cy="10" r="1" />
			</svg>
		),
		animation: {
			initial: { y: 0, pathLength: 0, strokeWidth: 2 },
			hover: {
				y: [0, -5, 0],
				pathLength: [0, 1],
				strokeWidth: [2, 3, 2],
				transition: { duration: 0.6, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.5 },
			},
		},
		submenu: [
			{ title: "Eventos", href: "/eventos" },
			{ title: "Inglés", href: "/aprende-ingles" },
			{ title: "Sala Privada", href: "/rol-en-replay" },
		],
	},
];

const itemVariants = {
	hidden: { opacity: 0, y: 20 },
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			type: "spring",
			stiffness: 300,
			damping: 24,
		},
	},
};

const submenuVariants = {
	closed: {
		opacity: 0,
		height: 0,
		overflow: "hidden",
		transition: {
			duration: 0.2,
			ease: "easeInOut",
			when: "afterChildren",
		},
	},
	open: {
		opacity: 1,
		height: "auto",
		transition: {
			duration: 0.3,
			ease: "easeOut",
			when: "beforeChildren",
			staggerChildren: 0.05,
		},
	},
};

const submenuItemVariants = {
	closed: { opacity: 0, x: -10 },
	open: {
		opacity: 1,
		x: 0,
		transition: { duration: 0.2 },
	},
};

const DropdownArrow = ({ hasSubmenu, isOpen = false }: { hasSubmenu: boolean; isOpen?: boolean }) => {
	if (!hasSubmenu) return null;

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={`ml-1 dropdown-arrow transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
		>
			<polyline points="6 9 12 15 18 9"></polyline>
		</svg>
	);
};

export const NavMenu = () => {
	const [openMobileSubmenus, setOpenMobileSubmenus] = useState<{ [key: string]: boolean }>({});
	const [useDesktopMenu, setUseDesktopMenu] = useState(false);
	const [isCompactView, setIsCompactView] = useState(false);

	useEffect(() => {
		const checkWidth = () => {
			const width = window.innerWidth;
			setUseDesktopMenu(width >= 768);
			setIsCompactView(width < 1024);
		};

		checkWidth();
		window.addEventListener("resize", checkWidth);
		return () => window.removeEventListener("resize", checkWidth);
	}, []);

	const toggleMobileSubmenu = (title: string) => {
		setOpenMobileSubmenus((prev) => ({
			...prev,
			[title]: !prev[title],
		}));
	};

	const renderDesktopMenu = () => (
		<motion.ul
			className="flex flex-row gap-x-2 lg:gap-x-4"
			initial="hidden"
			animate="visible"
			variants={{
				hidden: {},
				visible: {
					transition: {
						staggerChildren: 0.1,
					},
				},
			}}
		>
			{menu.map((item, index) => (
				<motion.li key={item.title} className="relative group" variants={itemVariants} custom={index}>
					<Link
						href={item.href}
						className="flex items-center gap-x-1 md:gap-x-2 px-2 md:px-3 lg:px-4 py-2 text-xs md:text-sm font-medium text-white hover:bg-gray-800 rounded-md transition"
					>
						<motion.div
							initial="initial"
							whileHover="hover"
							animate="initial"
							variants={item.animation}
							className="scale-75 md:scale-90 lg:scale-100"
						>
							{item.icon}
						</motion.div>
						<span
							className={`whitespace-nowrap transition-all duration-200 ${
								isCompactView
									? "opacity-0 group-hover:opacity-100 absolute left-full ml-2 bg-gray-900 px-2 py-1 rounded-md shadow-lg z-50 min-w-max"
									: "opacity-100"
							}`}
						>
							{item.title}
						</span>
						<DropdownArrow hasSubmenu={item.submenu.length > 0} />
					</Link>

					{item.submenu.length > 0 && (
						<div className="absolute left-0 hidden group-hover:block bg-gray-900 text-white shadow-lg rounded-md z-10 submenu-container">
							<ul className="flex flex-col gap-y-1 p-2 md:p-3">
								{item.submenu.map((submenuItem) => (
									<motion.li
										key={submenuItem.title}
										variants={submenuItemVariants}
										initial="closed"
										animate="open"
									>
										<Link
											href={submenuItem.href}
											className="block px-3 md:px-4 py-1 md:py-2 text-xs md:text-sm hover:bg-red-400 hover:text-black rounded-md transition whitespace-nowrap"
										>
											{submenuItem.title}
										</Link>
									</motion.li>
								))}
							</ul>
						</div>
					)}
				</motion.li>
			))}
		</motion.ul>
	);

	return (
		<nav className="bg-black nav-menu">
			{/* Desktop menu - dynamically shown based on viewport */}
			<div className={`${useDesktopMenu ? "flex" : "hidden"} items-center justify-center`}>
				{renderDesktopMenu()}
			</div>

			{/* Mobile menu - dynamically shown based on viewport */}
			<div className={`${!useDesktopMenu ? "block" : "hidden"}`}>
				<NavMobileMenu>
					<ul className="flex flex-col gap-y-2 p-4 bg-black text-white mobile-menu">
						{menu.map((item) => (
							<li key={item.title} className="relative">
								{item.submenu.length > 0 ? (
									<button
										onClick={() => toggleMobileSubmenu(item.title)}
										className="flex items-center gap-x-2 px-4 py-2 text-sm hover:bg-gray-700 rounded-md transition w-full justify-between"
									>
										<div className="flex items-center gap-x-2">
											<motion.div
												initial="initial"
												whileHover="hover"
												animate="initial"
												variants={item.animation}
											>
												{item.icon}
											</motion.div>
											<span>{item.title}</span>
										</div>
										<DropdownArrow hasSubmenu={true} isOpen={openMobileSubmenus[item.title]} />
									</button>
								) : (
									<Link
										href={item.href}
										className="flex items-center gap-x-2 px-4 py-2 text-sm hover:bg-gray-700 rounded-md transition w-full justify-between"
									>
										<div className="flex items-center gap-x-2">
											<motion.div
												initial="initial"
												whileHover="hover"
												animate="initial"
												variants={item.animation}
											>
												{item.icon}
											</motion.div>
											<span>{item.title}</span>
										</div>
									</Link>
								)}

								{item.submenu.length > 0 && (
									<motion.div
										className="ml-6 mt-2 overflow-hidden"
										initial="closed"
										animate={openMobileSubmenus[item.title] ? "open" : "closed"}
										variants={submenuVariants}
									>
										<ul className="flex flex-col gap-y-1">
											{item.submenu.map((submenuItem) => (
												<motion.li key={submenuItem.title} variants={submenuItemVariants}>
													<Link
														href={submenuItem.href}
														className="block px-4 py-2 text-sm hover:bg-gray-700 rounded-md transition"
													>
														{submenuItem.title}
													</Link>
												</motion.li>
											))}
										</ul>
									</motion.div>
								)}
							</li>
						))}
					</ul>
				</NavMobileMenu>
			</div>
		</nav>
	);
};
